"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkVersionAndCache = checkVersionAndCache;
exports.clearAppCache = clearAppCache;
exports.clearBrowserCache = clearBrowserCache;
exports.initAutoCacheUpdate = initAutoCacheUpdate;
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 自动版本检测和缓存更新工具
 */

// 获取应用版本号（从package.json或manifest中获取）
function getAppVersion() {
  try {
    // 从localStorage获取版本号，如果没有则从配置文件获取
    var storedVersion = localStorage.getItem('admin_app_version');
    if (storedVersion) {
      return storedVersion;
    }

    // 从package.json获取版本号（如果有的话）
    var packageJson = require('../../package.json');
    return packageJson.version || '1.0.0';
  } catch (e) {
    console.log('获取版本号失败:', e);
    return '1.0.0';
  }
}

// 获取最后一次缓存清理的时间戳
function getLastCacheClearTime() {
  return localStorage.getItem('admin_last_cache_clear') || 0;
}

// 设置最后一次缓存清理的时间戳
function setLastCacheClearTime() {
  localStorage.setItem('admin_last_cache_clear', Date.now().toString());
}

// 检测是否需要清理缓存
function shouldClearCache() {
  var lastClearTime = getLastCacheClearTime();
  var currentTime = Date.now();

  // 如果距离上次清理超过24小时，自动清理一次
  var twentyFourHours = 24 * 60 * 60 * 1000;
  return currentTime - lastClearTime > twentyFourHours;
}

// 清理应用缓存
function clearAppCache() {
  try {
    console.log('开始清理应用缓存...');

    // 清理localStorage中的缓存数据（保留重要数据）
    var preserveKeys = ['admin_token', 'admin_user_info', 'admin_permissions', 'admin_app_version', 'admin_last_cache_clear', 'admin_theme', 'admin_language', 'size'];
    var keysToRemove = [];
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key && !preserveKeys.includes(key)) {
        // 检查是否是缓存数据（通常以cache_或temp_开头，或包含时间戳）
        if (key.startsWith('cache_') || key.startsWith('temp_') || key.includes('_timestamp') || key.includes('_expires')) {
          keysToRemove.push(key);
        }
      }
    }

    // 删除缓存数据
    keysToRemove.forEach(function (key) {
      localStorage.removeItem(key);
    });
    console.log("\u6E05\u7406\u5B8C\u6210\uFF0C\u5DF2\u5220\u9664 ".concat(keysToRemove.length, " \u9879\u7F13\u5B58\u6570\u636E"));
    setLastCacheClearTime();
    return true;
  } catch (e) {
    console.error('清理应用缓存失败:', e);
    return false;
  }
}

// 检测新版本并处理缓存
function checkVersionAndCache() {
  var currentVersion = getAppVersion();
  var lastVersion = localStorage.getItem('admin_last_version');
  console.log('版本检测:', '当前版本', currentVersion, '上次版本', lastVersion);

  // 如果是新版本或初次运行
  if (!lastVersion || lastVersion !== currentVersion) {
    console.log('检测到版本更新或首次运行，开始清理缓存');
    clearAppCache();

    // 更新存储的版本号
    localStorage.setItem('admin_last_version', currentVersion);
    localStorage.setItem('admin_app_version', currentVersion);

    // 显示更新提示（可选）
    setTimeout(function () {
      if (window.Vue && window.Vue.prototype.$message) {
        window.Vue.prototype.$message.success('应用已更新，缓存已清理');
      }
    }, 1000);
  }

  // 定期清理缓存
  if (shouldClearCache()) {
    console.log('定期清理缓存');
    clearAppCache();
  }
}

// 手动清理浏览器缓存
function clearBrowserCache() {
  return new Promise(function (resolve, reject) {
    try {
      // 清理localStorage
      var preserveKeys = ['admin_token', 'admin_user_info', 'admin_permissions', 'admin_app_version', 'admin_last_version', 'admin_theme', 'admin_language', 'size'];
      var keysToRemove = [];
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (key && !preserveKeys.includes(key)) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(function (key) {
        localStorage.removeItem(key);
      });

      // 清理sessionStorage
      sessionStorage.clear();

      // 尝试清理缓存存储（如果支持）
      if ('caches' in window) {
        caches.keys().then(function (names) {
          names.forEach(function (name) {
            caches.delete(name);
          });
        });
      }
      setLastCacheClearTime();
      console.log('浏览器缓存清理完成');
      resolve(true);
    } catch (e) {
      console.error('清理浏览器缓存失败:', e);
      reject(e);
    }
  });
}

// 初始化自动缓存更新
function initAutoCacheUpdate() {
  // 页面加载完成后执行版本检测和缓存清理
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      checkVersionAndCache();
    });
  } else {
    // 页面已经加载完成
    checkVersionAndCache();
  }

  // 监听页面显示事件（从后台切换到前台）
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      // 页面变为可见时检查缓存
      if (shouldClearCache()) {
        console.log('页面重新激活，检查缓存清理');
        clearAppCache();
      }
    }
  });

  // 监听页面刷新或重新加载
  window.addEventListener('beforeunload', function () {
    // 页面卸载前的清理工作（可选）
  });
}

// 导出手动清理函数